import VisuallyHidden from "@reach/visually-hidden";
import React from "react";

export const RestPlusCopy = () => {
  return (
    <React.Fragment>
      <span aria-hidden="true">
        Rest<sup className="plus">+</sup>
      </span>
      <VisuallyHidden>Rest Plus</VisuallyHidden>
    </React.Fragment>
  );
};

export default RestPlusCopy;
